import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Fieldhand',
    description: "Build, run and monitor AI agents without code. See every agent's activity, performance, cost and impact in one calm view.",
    url: getOrigin(),
    ogImage: 'https://agentix.cdn.modulify.website/images/share/agentix-landscape.jpg',
    links: {
        x: 'https://x.com',
        instagram: 'https://www.instagram.com',
        linkedin: 'https://www.linkedin.com'
    }
}
